// Breadcrumb.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';

const renderBreadcrumb = (items: any[], className: string) => {
  const { t } = useTranslation();

  return (
    <div className={`${className} breadcrumb-font`}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.link ? (
            <span 
              className="cursor-pointer link-underline"
              onClick={() => window.location.href = item.link}
            >
              {t(item.text)}
            </span>
          ) : (
            <span className={item.bolder ? "breadcrumb-font-bolder" : ""}>{t(item.text)}</span>
          )}
          {index < items.length - 1 && " > "}
        </React.Fragment>
      ))}
    </div>
  );
}

export default renderBreadcrumb;